<template>
	<div>
		<div class="">
			<div
				class="archivetest-cards"
				:class="test.view || test.clone ? 'archivechangecolor' : ''"
			>
				<div class="d-flex w-100 align-items-center">
					<div style="width: 5%">
						<img src="@/assets/inactive.svg" alt="" />
					</div>
					<div
						class="tp-text tp-cardhead text-truncate ml-1"
						style="width: 65%"
					>
						<span v-b-popover.hover.top="test.testName">
							{{ test.testName }}
						</span>
					</div>
					<div
						style="width: 30%"
						class="d-flex justify-content-end align-items-center"
					>
						<img
							v-b-popover.hover.top="'Public'"
							v-if="test.publicAvailability"
							src="../../assets/Testunlockgreen.svg"
							alt=""
						/>
						<img
							v-if="!test.publicAvailability"
							v-b-popover.hover.top="'Private'"
							src="../../assets/Testlockred.svg"
							alt=""
						/>
						<img
							v-if="roles.includes('ACTIVATE_TEST')"
							v-b-popover.hover.top="'Clone Test'"
							@click="
								toggleview('clone', test.testID),
									$emit('archivetestmodal', {
										testID: test.testID,
										name: test.testName,
										publicAvailability: test.publicAvailability,
									})
							"
							src="../../assets/icons/Archivetest/archivetagtest.svg"
							alt=""
							class="ml-1 pointer"
						/>
						<img
							v-b-popover.hover.top="'Preview'"
							v-if="
								!test.view &&
									this.roles.includes('GET_QUESTION') &&
									this.roles.includes('GET_SECTION')
							"
							@click="toggleview('view', test.testID), saveTestPreview()"
							src="../../assets/icons/Archivetest/vieweye.svg"
							class="ml-1 pointer"
							alt=""
						/>
						<img
							v-b-popover.hover.top="'Close'"
							v-else-if="
								this.roles.includes('GET_QUESTION') &&
									this.roles.includes('GET_SECTION')
							"
							@click="
								toggleview('view', null), $emit('toggleTestPreview', false)
							"
							src="../../assets/visibility_off.svg"
							class="ml-1 pointer"
							alt=""
						/>
					</div>
				</div>
				<div class="archive-tst-topicbox mt-3">
					<div class="archivecards-topicnametxt">Topic Name :</div>

					<div class="archivecards-topictxt text-truncate">
						<span v-b-popover.hover.top="test.topicName">
							{{ test.topicName }}
						</span>
					</div>
				</div>

				<div
					class="archive-tst-innerbox d-flex justify-content-around align-items-center mt-2"
				>
					<div class="d-flex align-items-center flex-column">
						<span class="greennumbertext">{{ test.numberOfSections }}</span>
						<span class="tp-cardhead">Sections</span>
					</div>
					<div class="d-flex align-items-center flex-column">
						<span class="yellownumbertext">{{ test.marks }}</span>
						<span class="tp-cardhead">Marks</span>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
	name: "Archivedcardview",
	data() {
		return {
			cards: 25,
		};
	},
	props: {
		test: Object,
	},
	computed: {
		...mapGetters(["roles"]),
	},
	methods: {
		async saveTestPreview() {
			console.log("before emit");
			this.$emit("toggleTestPreview", true);
			console.log("after emit");
			this.$store.commit("autotestVUEX/saveSelectedAutoTest", this.test);
			await this.$store.dispatch("sectionVUEX/getSection", this.test.testID);
		},
		toggleview(key, data) {
			this.$emit("toggleview", key, data);
		},
	},
};
</script>

<style>
.archivechangecolor {
	border: 2px solid #84bae7 !important;
	border-radius: 8px;
	background: #ebf5fe;
}
.tagtest-head {
	font-weight: 400;
	font-size: 13px;
	color: #72738e;
}
#archivetestmodal .modal-body {
	height: calc(100vh - 125px);
}
.paginaTion {
	position: absolute;
	width: 100%;
	padding: 5px 10px;
	bottom: 0;
	box-shadow: 0px 0px 5px rgb(0 0 0 / 15%);
	border-radius: 0px 0px 5px 5px;
	background: #f2f4fd;
	z-index: 1;
}
.archivesections-txt {
	font-weight: 400;
	font-size: 13px;

	color: #696969;
}
.archivegreennumbertext {
	font-weight: 500;
	font-size: 14px;

	color: #038e00;
}
.archivebluenumbertext {
	font-weight: 500;
	font-size: 14px;

	color: #84a3fe;
}
.archiveyellownumbertext {
	font-weight: 500;
	font-size: 14px;

	color: var(--cv-yellow);
}
.archivetest-list-cards {
	background: #ffffff;
	box-shadow: 0px 4px 20px rgba(196, 196, 196, 0.5);
	border-radius: 8px;
	height: 80px;
	position: relative;
}
.archivelist-topictxt {
	font-weight: 400;
	font-size: 13px;
	color: #696969;
}
.archivelist-testtxt {
	font-weight: 600;
	font-size: 14px;
	color: #1a4164;
}
.archivetestcheckbox .custom-control-label::before {
	background-color: #eef2f5;
	border-radius: 2px;
	top: 2px;
}
.archivetestcheckbox .custom-control-label::after {
	top: 2px;
}
.archivetestcheckbox .custom-control-label {
	position: relative;
	margin-bottom: 0;
	vertical-align: top;
	font-weight: 500;
	font-size: 14px;

	color: #696969;
}
</style>
